export const getVimeoUrl = (
  videoId: string,
  opts:
    | { background: true }
    | Partial<{
        autoplay: boolean;
        autopause: boolean;
        loop: boolean;
        muted: boolean;
        controls: boolean;
      }>
): string => {
  const url = new URL(`https://player.vimeo.com/video/${videoId}`);

  if ('background' in opts) {
    url.searchParams.append('background', '1');
    url.searchParams.append('loop', '1');
    url.searchParams.append('autopause', '0');
    return url.toString();
  }

  if (opts.autoplay) {
    url.searchParams.append('autoplay', '1');
  }

  if (!opts.autopause) {
    url.searchParams.append('autopause', '0');
  }

  if (opts.loop) {
    url.searchParams.append('loop', '1');
  }
  if (opts.muted) {
    url.searchParams.append('muted', '1');
  }
  if (!opts.controls) {
    url.searchParams.append('controls', '0');
  }

  return url.toString();
};
